import { AuthActions, EAuthActions } from './auth.actions';
import { IAuthState, initialAuthState } from './auth.state';

export const authReducers = (
  state = initialAuthState,
  action: AuthActions
): IAuthState => {
  switch (action.type) {
    case EAuthActions.RequestFailure: {
      return {
        ...state,
        errors: action.errors,
        loading: {},
      };
    }
    case EAuthActions.LoginSuccess: {
      return {
        ...state,
        user: action.user,
        errors: {},
        isAuth: true,
        loading: { ...state.loading, login: false },
      };
    }
    case EAuthActions.LogoutSuccess: {
      return {
        ...state,
        user: {},
        errors: {},
        isAuth: false,
      };
    }
    case EAuthActions.UpdateStateMessage: {
      return {
        ...state,
        message: action.message,
      };
    }
    case EAuthActions.ResetPasswordRequestSuccess: {
      return {
        ...state,
        message: action.message,
        errors: {},
        loading: { ...state.loading, resetPassword: false },
      };
    }
    case EAuthActions.UpdateAuthUser: {
      return { ...state, user: { ...state.user, ...action.user } };
    }

    case EAuthActions.GetTokenValiditySuccess: {
      return {
        ...state,
        isValidToken: true,
        errors: {},
        loading: { ...state.loading, tokenValidity: false },
      };
    }
    case EAuthActions.GetTokenValidity: {
      return {
        ...state,
        loading: { ...state.loading, tokenValidity: true },
      };
    }
    default:
      return state;
  }
};
